import { createPortal } from 'react-dom';
import React, { Fragment, useState, useContext, useRef, useEffect } from 'react';
import { withStyles, Grid, Drawer, Divider } from '@material-ui/core';
import DataContext from '../data/DataContext';
import Close from '../../asset/img/icon_close.svg';

const styles = (theme) => ({
  root: {
    position: 'fixed',
    zIndex: '1300',
    inset: '0px',
  },
  drawerFrame: {
    borderRadius: '10px',
    borderBottomRightRadius: 0,
    borderBottomLeftRadius: 0,
    height: '90%',
    overflowY: 'auto',
    top: 'auto',
    left: '0',
    right: '0',
    bottom: '0',
    maxHeight: '100%',
    display: 'flex',
    outline: '0',
    zIndex: '1200',
    position: 'fixed',
    flexDirection: 'column',
    boxShadow:
      '0px 8px 10px -5px rgba(0, 0, 0, 0.2), 0px 16px 24px 2px rgba(0, 0, 0, 0.14), 0px 6px 30px 5px rgba(0, 0, 0, 0.12)',
    color: 'rgba(0, 0, 0, 0.87)',
    backgroundColor: '#fff',
  },
  drawerRoot: {
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'hidden',
  },
  dialogContainerBackdrop: {
    opacity: '1',
    transition: 'opacity 225ms cubic-bezier(0.4, 0, 0.2, 1)',
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    display: 'flex',
    zIndex: '-1',
    position: 'fixed',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  titleCloseTop: {
    fontFamily: 'inherit',
    fontSize: theme.font.size18,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.33',
    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#000',
    width: '100%',
    padding: '1px 0px',
  },
  titleArrow: {
    display: 'flex',
    margin: '20px 0 19.5px 16px',
    fontFamily: 'inherit',
    fontSize: '18px',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.33',
    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#000',
  },
  divider: {
    height: '1px',
    background: '#000',
    margin: '0px 14px 19.5px 14px',
  },
  closeArrow: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& img': {
      width: '16px',
      height: '16px',
      cursor: 'pointer',
    },
  },
  closeTop: {
    display: 'flex',
    justifyContent: 'end',
    '& img': {
      width: '24px',
      height: '24px',
      cursor: 'pointer',
    },
    border: 'none',
    background: 'none',
  },
  drawerHeaderClose: {
    display: 'flex',
    minHeight: 'auto', //"46px",
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '10px 16px',
  },
  drawerHeaderCloseTop: {
    display: 'flex',
    minHeight: 'auto:', //"46px",
    justifyContent: 'space-between',
    alignItems: 'center',
    // padding: "10px 9px 10px 14px",
    padding: '16px 16px 6px 16px',
    flexDirection: 'row',
  },
  componentWrapper: {
    overflowY: 'auto',
  },
  modalFooter: {
    width: '100%',
    display: 'flex',
    padding: ' 14px 16px',
    marginTop: '16px',
    placeContent: 'center',
    borderTop: '1px solid #ddd',
  },
  modalButtonLeft: {
    paddingRight: '4px',
  },
  modalButtonRight: {
    paddingLeft: '4px',
  },
  modalButton: {
    width: '100%',
    height: '50px',
    borderRadius: '6px',
    border: 'solid 1px #ddd',
    backgroundColor: '#fff',
    // margin: "0px 4px",
    fontFamily: 'NotoSansKR',
    fontSize: '14px',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.43',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: '#000',
  },
  modalButtonDefault: {
    color: '#bbb',
    backgroundColor: '#999',
    border: '0px',
  },
  modalButtonStrong: {
    color: '#fff',
    backgroundColor: '#ea1917', //"#da0f47",
    border: '0px',
    fontWeight: 'bold',
  },
  modalButtonStrongDisabled: {
    color: '#bbb',
    backgroundColor: '#999',
  },
  modalGridContainer: {
    padding: '0px 16px',
  },
  modalGridItem: {
    marginBottom: '6px',
  },
  itemButton: {
    padding: '12px',
    width: '100%',
    height: '100%',
    border: '1px solid #fff',
    cursor: 'pointer',
    borderRadius: '6px',
    background: '#f6f6f6',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  selected: {
    background: '#fff',
    border: '1px solid #000',
    borderRadius: '6px',
  },
  itemImg: {
    width: '90px',
    height: '70px',
    marginRight: '20px',
    borderRadius: '5px',
    background: '#fff',
  },
  imageStyle: {
    width: '100%',
    objectFit: 'contain',
  },
  itemTitle: {
    fontFamily: 'inherit',
    fontSize: theme.font.size14,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.36',
    letterSpacing: 'normal',
    color: '#000',
    textAlign: 'left',
  },
  itemText: {
    paddingTop: '2px',
    fontFamily: 'inherit',
    fontSize: theme.font.size12,
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.33',
    letterSpacing: 'normal',
    color: '#000',
    textAlign: 'left',
  },
  modalPlainBtn: {
    minHeight: '46px',
    borderRadius: '6px',
    border: 'solid 1px #000',
    backgroundColor: '#fff',
    width: '100%',
    fontFamily: 'inherit',
    fontSize: theme.font.size14,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: '1.43',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: '#000',
  },
  modalInnerItem: {
    padding: '0px',
    paddingRight: '8px',
  },
  modalInnerItemLast: {
    paddingRight: '0px',
  },
  infoIcon: {
    width: '16px',
    height: '16px',
  },
  textareaField: {
    position: 'relative',
  },
  textarea: {
    width: '100%',
    height: '150px',
    borderRadius: '6px',
    background: '#fff',
    font: 'inherit',
    fontSize: '14px',
    padding: '13px 16px 35px',
  },
  textCount: {
    font: 'inherit',
    fontSize: '12px',
    letterSpacing: 'normal',
    position: 'absolute',
    bottom: '14px',
    right: '16px',
  },
  nextLine: {
    paddingBottom: 0,
  },
  disabled: {
    background: '#ededed',
    border: '0px !important',
  },
  showAll: {
    fontWeight: 'bold',
    fontSize: theme.font.size12,
    letterSpacing: 'normal',
    textDecoration: 'underline',
    // cursor: 'pointer',
    background: 'none',
    border: 'none',
    color: '#000',
  },
  terms: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  termTextArea: {
    height: '120px',
    overflowY: 'auto',
    border: '1px solid #929292',
    borderRadius: '6px 6px 0 0',
    fontSize: theme.font.size12,
    padding: '16px',
    lineHeight: '18px',
  },
  termTextTitle: {
    fontWeight: 'bold',
  },
  checkArea: {
    height: '48px',
    border: '1px solid #929292',
    borderTop: 'none',
    borderRadius: '0 0 6px 6px',
    fontSize: theme.font.size12,
    display: 'flex',
    alignItems: 'center',
    padding: '16px',
    '& label': {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      fontSize: theme.font.size14,
      fontWeight: 'bold',
    },
    '& input': {
      height: '20px',
      width: '20px',
      marginRight: '6px !important',
    },
    '& input.error': {},
  },
  errorIcon: {
    width: '12px',
    height: '12px',
    color: '#ff3723',
    marginRight: '3px',
  },
  errorText: {
    color: '#ff3723',
    fontSize: theme.font.size13,
    display: 'flex',
    alignItems: 'center',
    paddingTop: '8px',
  },
});

const InstallType = withStyles(styles)((props) => {
  const {
    classes,
    modalClose,
    parentFunc,
    curModalValue,
    scrollRef,
    updateModalValue,
    orgData,
  } = props;
  const [selected, setSelected] = useState(curModalValue);
  const options = orgData?.data?.install_type_data?.Items || [];
  const slotEntity = orgData?.data?.install_type_data?.SlotEntity;

  const hasPrev = parentFunc?.getPrevModal() !== '';
  const hasNext = parentFunc?.getNextModal() !== '';

  const handlePrev = () => {
    modalClose('prev');
  };
  const handleNext = () => {
    modalClose('next');
  };
  const scrollDown = () => {
    scrollRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
  };
  return (
    <div ref={scrollRef}>
      <Grid container className={classes.modalGridContainer}>
        {options.map((option, index) => (
          <Grid
            key={`rserve-install-${index}`}
            item
            xs={12}
            className={classes.modalGridItem}
          >
            <button
              className={[
                classes.itemButton,
                index === selected ? classes.selected : null,
              ].join(' ')}
              onClick={() => {
                updateModalValue(index);
                setSelected(index);
                scrollDown();
              }}
              title={index === selected ? '선택됨' : null}
            >
              <div className={classes.itemImg}>
                <img className={classes.imageStyle} src={option.Image} alt="" />
              </div>
              <div className={classes.itemTitle}>{option.Label}</div>
              {/* <div className={classes.itemText}>{option.text}</div> */}
            </button>
          </Grid>
        ))}
      </Grid>
      {/* footer button */}
      <Grid container className={classes.modalFooter}>
        {hasPrev && (
          <Grid item xs={6} className={classes.modalButtonLeft}>
            <button className={[classes.modalButton].join(' ')} onClick={handlePrev}>
              이전
            </button>
          </Grid>
        )}
        <Grid item xs={hasPrev ? 6 : 12} className={classes.modalButtonRight}>
          <button
            disabled={selected === null}
            className={[
              classes.modalButton,
              classes.modalButtonStrong,
              selected === null && classes.modalButtonStrongDisabled,
            ].join(' ')}
            onClick={handleNext}
          >
            다음
          </button>
        </Grid>
      </Grid>
    </div>
  );
});

function ReserveInstall(props) {
  const {
    classes,
    data,
    modalOpen,
    modalClose,
    curModalValue,
    updateModalValue,
    parentFunc,
  } = props;
  const { orgData, modalValue, linkData } = data || {
    orgData: null,
    modalValue: null,
    linkData: null,
  };
  const context = useContext(DataContext);
  const scrollRef = useRef(null);
  const modalRef = useRef();

  useEffect(() => {
    if (modalOpen) {
      // 웹접근성 - 모달팝업 포커스 25-01
      const { current: modalElement } = modalRef;
      window.setTimeout(() => {
        modalElement.focus();
      });
    }
  }, [modalOpen]);

  const cancelReserve = () => {
    const defaultParameters = linkData?.parameters;
    const defaultExpect = linkData?.expect;
    let expectIntent = '';
    let byPassBrObj = { bypass_br: 'cancel' };
    expectIntent = 'THQ_ENGINEER_BOOK_BYPASS';
    context.request(
      context,
      defaultParameters?.speech || '취소',
      'button',
      {
        ...defaultParameters,
        ...byPassBrObj,
      },
      defaultExpect || {
        mode: 'bypass',
        intent: expectIntent,
      }
    );

    const rootChild = document.getElementById('root');
    const focusableElements = rootChild.querySelectorAll('*');

    for (let i = 0; i < focusableElements.length; i++) {
      focusableElements[i].removeAttribute('aria-hidden');
    }

    modalClose();
  };

  return createPortal(
    <div className={classes.root}>
      {/* <Drawer
        anchor="bottom"
        open={modalOpen}
        onClose={cancelReserve}
        classes={{ paper: classes.drawerFrame }}
      > */}
      {modalOpen && (
        <div>
          <div
            className={classes.dialogContainerBackdrop}
            aria-hidden="true"
            onClick={cancelReserve}
          ></div>
          <div className={classes.drawerFrame}>
            <div className={classes.drawerRoot}>
              <div className={classes.drawerHeaderCloseTop}>
                <div className={classes.titleCloseTop} ref={modalRef} tabIndex="0">
                  {' '}
                  원활한 서비스 진행을 위해 제품의 설치 형태를 선택해 주세요.{' '}
                </div>
                <button className={classes.closeTop} onClick={cancelReserve}>
                  <img src={Close} className={classes.arrowDown} alt="닫기" />
                </button>
              </div>
              <Divider classes={{ root: classes.divider }} />
              <div className={classes.componentWrapper}>
                <InstallType
                  curModalValue={curModalValue}
                  orgData={orgData}
                  modalOpen={modalOpen}
                  updateModalValue={updateModalValue}
                  scrollRef={scrollRef}
                  modalClose={modalClose}
                  parentFunc={parentFunc}
                />
              </div>
            </div>
          </div>
        </div>
      )}
      {/* </Drawer> */}
    </div>,
    document.getElementById('modal')
  );
}
export default withStyles(styles)(ReserveInstall);
